import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M26.07 10.01c-2.479.848-10.915 6.071-14.831 9.333-1.834 1.527-3.887 2.85-5.12 3.643-.777.5-1.229.79-1.096.792L31 24v-.176c-1.742-.072-1.794-.113-2.632-.772l-.157-.123c-3.309-3.04-5.422-9.088-2.774-12.293.047-.08.242-.24.412-.378.197-.162.361-.296.222-.248M5.28 24.7S5 24.491 5 24.333c0-.142.248-.333.248-.333l25.102.233.65.434-.464.333z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m6.5 10.072-.882.642.338-1.037-.883-.64h1.09L6.5 8l.336 1.037h1.09l-.882.64.338 1.037zm-4.882 4.642.882-.642.882.642-.338-1.037.882-.64h-1.09L2.5 12l-.336 1.037h-1.09l.882.64zm4 6 .882-.642.882.642-.338-1.037.882-.64h-1.09L6.5 18l-.336 1.037h-1.09l.882.64zm3.794-7.905.588-.428.588.428-.226-.691.589-.427h-.727L10 11l-.224.692-.727-.001.588.427z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagTkl = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagTkl_default = SvgFlagTkl;

export { FlagTkl_default as default };
